export default __webpack_public_path__ + "static/media/favicon-32x32.ca11953c.png";